import { LayoutItem } from 'api/models';

const layout = `{
  "layout": [
    {
      "id": "836d1427-3de6-49f8-acc6-b66a5298fdc6",
      "type": "container",
      "layoutOptions": {
        "layout": "12"
      },
      "children": [
        {
          "id": "5b82c331-39bb-4350-a993-396b47330902",
          "type": "container",
          "subType": "layout",
          "layoutOptions": {
            "layout": "12"
          },
          "children": [
            {
              "id": "8e0e4d18-a715-435d-a187-2b50af19a32c",
              "type": "container",
              "subType": "layout",
              "layoutOptions": {
                "layout": "4"
              },
              "children": [
                {
                  "id": "6e9c26f7-214d-4302-ba52-a7a91f336b59",
                  "type": "input",
                  "fieldTemplateId": "961dd91a-4e50-42fd-9832-2d4c627e5459",
                  "layoutOptions": {
                    "layout": "12"
                  },
                  "_id": "6e9c26f7-214d-4302-ba52-a7a91f336b59"
                }
              ]
            },
            {
              "id": "a83b3e6b-060c-444c-ab54-9d9ace55aef2",
              "type": "container",
              "subType": "layout",
              "layoutOptions": {
                "layout": "4"
              },
              "children": [
                {
                  "id": "855276e7-98bb-405d-ba61-585af3b596ad",
                  "type": "input",
                  "fieldTemplateId": "b23f5027-0cad-48ba-b61b-12303049db6a",
                  "layoutOptions": {
                    "layout": "12"
                  },
                  "_id": "855276e7-98bb-405d-ba61-585af3b596ad"
                }
              ]
            },
            {
              "id": "66793cb5-822b-413e-9741-98222cb32d9a",
              "type": "container",
              "subType": "layout",
              "layoutOptions": {
                "layout": "4"
              },
              "children": [
                {
                  "id": "d5ccc375-e074-4b21-a0d8-8d4b41eb0f70",
                  "type": "input",
                  "fieldTemplateId": "07d1a0ef-854f-461d-b3c7-50433f6e1b5d",
                  "layoutOptions": {
                    "layout": "12"
                  },
                  "_id": "d5ccc375-e074-4b21-a0d8-8d4b41eb0f70"
                }
              ]
            }
          ]
        },
        {
          "id": "04be9f56-c534-4ae7-a65e-c75d025844b9",
          "type": "container",
          "subType": "layout",
          "layoutOptions": {
            "layout": "12",
            "style": {
              "justifyContent": "end"
            }
          },
          "children": [
            {
              "id": "ed40e081-dcc5-4217-89d1-0440ba4db529",
              "type": "container",
              "subType": "layout",
              "layoutOptions": {
                "layout": "4"
              },
              "children": [
                {
                  "id": "2e89fbe4-0e0f-4484-984b-cf6df1dbe1b7",
                  "type": "input",
                  "fieldTemplateId": "2a05f707-5b5c-407a-9848-535d190a50b3",
                  "layoutOptions": {
                    "layout": "12"
                  },
                  "_id": "2e89fbe4-0e0f-4484-984b-cf6df1dbe1b7"
                }
              ]
            },
            {
              "id": "28ef9eda-e5d9-466e-9014-bb3effa64c3b",
              "type": "container",
              "subType": "layout",
              "layoutOptions": {
                "layout": "4"
              },
              "children": [
                {
                  "id": "ee4d076f-0e0a-4d7d-9ada-a4ecbddbd46b",
                  "type": "input",
                  "fieldTemplateId": "f5f3adf8-6075-4db2-8820-6600c2cc8985",
                  "layoutOptions": {
                    "layout": "12"
                  },
                  "_id": "ee4d076f-0e0a-4d7d-9ada-a4ecbddbd46b"
                }
              ]
            }
          ]
        },
        {
          "id": "2a658f9b-1ea5-4859-81b7-82d89ed2401a",
          "type": "container",
          "subType": "layout",
          "layoutOptions": {
            "layout": "12",
            "style": {
              "justifyContent": "start"
            }
          },
          "children": [
            {
              "id": "e830f88e-c67d-48e5-b8aa-ddccf56933ca",
              "type": "container",
              "subType": "layout",
              "layoutOptions": {
                "layout": "12"
              },
              "children": [
                {
                  "id": "bc7a56a9-933c-4e01-8271-2def27dea993",
                  "type": "input",
                  "fieldTemplateId": "291a266e-cc28-4a60-9cb3-f6715f2c76f5",
                  "layoutOptions": {
                    "layout": "12"
                  },
                  "_id": "bc7a56a9-933c-4e01-8271-2def27dea993"
                }
              ]
            }
          ]
        },
        {
          "id": "be8360c2-e7d2-45b8-b04b-afa16f5268e5",
          "type": "container",
          "subType": "layout",
          "layoutOptions": {
            "layout": "12",
            "style": {
              "justifyContent": "start"
            }
          },
          "children": [
            {
              "id": "0b854456-540e-4e4d-a886-3161518b2fc9",
              "type": "container",
              "subType": "layout",
              "layoutOptions": {
                "layout": "4"
              },
              "children": [
                {
                  "id": "b6cf2d7e-afbf-4710-8af0-041691e5b49e",
                  "type": "input",
                  "fieldTemplateId": "acb1152e-db7b-40b9-a8d8-8da588a8e58b",
                  "layoutOptions": {
                    "layout": "12"
                  },
                  "_id": "b6cf2d7e-afbf-4710-8af0-041691e5b49e"
                }
              ]
            },
            {
              "id": "67061904-5e14-42d2-bddd-5531882a6162",
              "type": "container",
              "subType": "layout",
              "layoutOptions": {
                "layout": "4"
              },
              "children": [
                {
                  "id": "a20b3bfc-f01c-4b15-9fb5-cee074ab8d6f",
                  "type": "input",
                  "fieldTemplateId": "e9ddb995-ab4a-42dc-8589-c580d4703e6f",
                  "layoutOptions": {
                    "layout": "12"
                  },
                  "_id": "a20b3bfc-f01c-4b15-9fb5-cee074ab8d6f"
                }
              ]
            },
            {
              "id": "e3a0938c-b9f3-4b12-87ac-3126bbe6a68b",
              "type": "container",
              "subType": "layout",
              "layoutOptions": {
                "layout": "4"
              },
              "children": [
                {
                  "id": "55e64255-c798-4a6b-83de-761bf2911e74",
                  "type": "input",
                  "fieldTemplateId": "c0390830-1627-4646-9fa1-b2ad601ba994",
                  "layoutOptions": {
                    "layout": "12"
                  },
                  "_id": "55e64255-c798-4a6b-83de-761bf2911e74"
                }
              ]
            }
          ]
        }
      ],
      "subType": "layout"
    }
  ]
}`;
export function getSampleLayout() {
  return JSON.parse(layout).layout as LayoutItem[];
}
